import React from 'react';

class SMFormFieldBaseView extends React.Component {
  
  constructor(props) {
    super(props);
    this.isChange = false;
  }

  errorFieldClassName(className, isError) {
    if (isError) className += " form-error ";
    return className;
  }
  
  errorTextClassName(className, isError) {
    if (isError) className += " is-error";
    return className;
  }
}
export default SMFormFieldBaseView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormFieldBaseView.js